import type { SupportedLanguage } from "@/lib/i18n/languages";

const PROTOCOL_PDF_COPY: Record<
  SupportedLanguage,
  { readonly viewPdfFailed: string }
> = {
  de: {
    viewPdfFailed:
      "Das PDF konnte nicht geöffnet werden. Bitte versuche es gleich noch einmal.",
  },
  en: {
    viewPdfFailed: "Could not open the PDF. Try again in a moment.",
  },
  fr: {
    viewPdfFailed:
      "Impossible d’ouvrir le PDF. Veuillez réessayer dans un instant.",
  },
  ar: {
    viewPdfFailed: "تعذر فتح ملف PDF. يرجى المحاولة بعد قليل.",
  },
  uk: {
    viewPdfFailed: "Не вдалося відкрити PDF. Спробуйте ще раз за мить.",
  },
  es: {
    viewPdfFailed:
      "No se pudo abrir el PDF. Inténtalo de nuevo en unos instantes.",
  },
};

export function getProtocolPdfCopy(language: SupportedLanguage) {
  return PROTOCOL_PDF_COPY[language];
}
